export default "__VITE_ASSET__CTBo2oup__"